import { KPI } from '../../../layout/KPI.jsx';
import { formatIQD } from '../../../shared/format.js';

function deltaText(current, previous) {
  if (previous == null || current == null) return null;
  if (!previous) return null;
  const pct = Math.round(((current - previous) / previous) * 100);
  if (Number.isNaN(pct)) return null;
  return { text: `${pct > 0 ? '+' : ''}${pct}% عن الفترة السابقة`, direction: pct < 0 ? 'down' : 'up' };
}

export function KpiGrid({ overview, activeSessions, pendingInvoices }) {
  const ov = overview || {};
  // ‏/reports/overview يعيد { period, kpis, deltas }. قراءة `today`/`totals`
  // (مفاتيح لا وجود لها) كانت تُظهر «—» في كل البطاقات رغم وجود بيانات.
  const k = ov.kpis || ov.today || ov.totals || {};
  const deltas = ov.deltas || {};

  const todayRevenue = k.totalRevenue ?? k.revenue ?? k.total ?? null;
  const prevRevenue = todayRevenue != null && deltas.totalRevenue != null
    ? todayRevenue - deltas.totalRevenue
    : null;
  const revenueDelta = deltaText(todayRevenue, prevRevenue);

  const insideNow =
    k.currentlyInside ??
    ov.activeChildren ??
    ov.insideNow ??
    (Array.isArray(activeSessions) ? activeSessions.length : activeSessions?.count) ??
    null;

  const pendingArr = Array.isArray(pendingInvoices)
    ? pendingInvoices
    : pendingInvoices?.rows || pendingInvoices?.data || pendingInvoices?.items || [];
  const pendingCount = pendingInvoices?.count ?? k.pendingInvoicesCount ?? pendingArr.length ?? 0;
  const pendingAmount = pendingInvoices?.totalDue
    ?? k.pendingInvoicesAmount
    ?? pendingArr.reduce(
      (s, x) => s + Number(x.dueAmount ?? x.totalAmount ?? x.amount ?? 0),
      0
    );

  const avgSpend = k.avgSpendPerChild ?? ov.avgPerChild ?? ov.averageSpend ?? null;

  const placeholder = '—';

  return (
    <div className="grid gap-3.5" style={{ gridTemplateColumns: 'repeat(4, minmax(0, 1fr))' }}>
      <KPI
        tone="orange"
        icon="finance"
        label="الإيرادات"
        value={todayRevenue != null ? formatIQD(todayRevenue) : placeholder}
        delta={revenueDelta?.text}
        deltaDirection={revenueDelta?.direction || 'up'}
      />
      <KPI
        tone="cyan"
        icon="children"
        label="أطفال داخل القاعة الآن"
        value={insideNow != null ? insideNow : placeholder}
      />
      <KPI
        tone="pink"
        icon="checkout"
        label="فواتير معلقة"
        value={pendingCount ? `${pendingCount}` : placeholder}
        delta={pendingAmount ? formatIQD(pendingAmount) : undefined}
        deltaDirection="down"
      />
      <KPI
        tone="yellow"
        icon="reports"
        label="متوسط الإنفاق لكل طفل"
        value={avgSpend != null ? formatIQD(avgSpend) : placeholder}
      />
    </div>
  );
}
